import React from 'react'
import PropTypes from 'prop-types'
import { Form, FormGroup } from 'react-bootstrap'
import ReactDatePicker from 'react-datepicker'
import { inject, observer } from "mobx-react"
import { parse, format } from 'date-fns'
import { TimePicker } from '../../ui/TempusDominus'

@inject("store")
@observer
export default class TimeField extends React.Component {
  render() {
    const { store, field } = this.props
    const { name, placeholder, uuid, hint, required } = field
    const instance = this.props.instance || 0
    const value = store.valueFor(uuid, "text", instance)
    const errorMessage = store.errorFor(uuid, "text", instance)
    const timeFormat = store.timeFormat

    return (
      <FormGroup>
        <Form.Label>{ required ? "*" : "" } {name}</Form.Label>
        <TimePicker
          id={`datetimepicker-${uuid}-${instance}`}
          value={value}
          onChange={value => store.setValueFor(uuid, "text", instance, value)}
          placeholder={placeholder}
          disabled={!store.editable}
          timeFormat={timeFormat}
          isInvalid={!!errorMessage}
        />
        { errorMessage && <Form.Control.Feedback type="invalid" style={{display: "block"}}>{errorMessage}</Form.Control.Feedback> }
        { hint && <Form.Text muted>{hint}</Form.Text > }
      </FormGroup>
    )
  }
}
